

    if (window.Sentry) {
      window.Sentry.init({ dsn: "https://cd2c8e8d2a11492b9ae615ed62ef6072@sentry.wixpress.com/3606", environment: 'Editor' });
    }
  

    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/work/7316bfa601ecc640/reviews-web/wix-reviews/src/components/CollectionWidget/Widget/index.tsx';
    import createController from '/home/builduser/work/7316bfa601ecc640/reviews-web/wix-reviews/src/components/CollectionWidget/controller.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


    
const multilingualDisabled = false;

    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    
import { createRavenClient } from '@wix/yoshi-flow-editor/error-monitor';
    import Raven from '@wix/yoshi-flow-editor/raven-js';
    var createErrorMonitor = function(options) {
      return createRavenClient({
        Raven,
        ...options,
      });
    };
    

    
import { I18nextProvider } from '@wix/yoshi-flow-editor/i18n';


      import { PureExperimentsProvider } from '@wix/yoshi-flow-editor';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { PanoramaProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/PanoramaProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

import { TPAComponentsProvider } from 'wix-ui-tpa';

import { BaseUiEnvironmentProviderWrapper } from '@wix/yoshi-flow-editor/runtime/esm/react/BaseUiEnvironmentProviderWrapper';

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  PanoramaProvider,
  HttpProvider,
  TPAComponentsProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  import * as viewerApp from '/home/builduser/work/7316bfa601ecc640/reviews-web/wix-reviews/src/viewer.app.ts';
    var importedApp = viewerApp;

    var componentName = 'CollectionWidget';
    var projectName = 'wix-reviews';
    var sentryConfig = {
      DSN: 'https://cd2c8e8d2a11492b9ae615ed62ef6072@sentry.wixpress.com/3606',
      id: 'ddac5f9ae34511ec9fff0242ac12001c',
      projectName: 'wix-reviews',
      teamName: 'forum',
      errorMonitor: true,
    };
    

    import * as usersStyleParamsEntry from '/home/builduser/work/7316bfa601ecc640/reviews-web/wix-reviews/src/components/CollectionWidget/stylesParams.ts';
var stylesParamsEntry = usersStyleParamsEntry;
var stylesParams = stylesParamsEntry.default;
var customCssVars = stylesParamsEntry.customCssVars || function() { return {} };
    


    var experimentsConfig = {"scopes":["todo-viewer-apps-95a5fce-e370-4402-9ce4-96956acc747d"],"centralized":true};
    var fedopsConfig = null;
    var translationsConfig = {"enabled":true,"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/7316bfa601ecc640/reviews-web/wix-reviews/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};
    var defaultTranslations = {"toast.error-review-publish-duplicate":"Seems like you’ve already reviewed this product.","toast.error-review-publish-unknown":"Could not publish your review. Please try again later.","toast.error-review-publish-permission":"It looks like you don't have the right permissions to publish that review.","toast.error-review-publish-invalid-request-link":"It looks like the request link is invalid.","error-boundary-fallback.message":"There’s a technical issue. Refresh the page and try again.","error-boundary-fallback.button-label":"Refresh","not-found-error.message":"Review request not found","not-found-error.button-label":"Continue","editor-field-input.placeholder-text":"This is placeholder text and it will not appear live.","field-error.invalid-email":"This email is not valid","field-error.required.email":"Enter an email address, like example@email.com","field-error.required.rating":"Select a star rating.","field-error.required.body":"Write your review.","field-error.required.title":"Write a title for your review.","field-error.required.media":"Add at least one image or video.","field-error.media-still-uploading":"Media is still uploading","field-error.required.name":"Enter a reviewer's name.","field-label.required":"This field is required.","field-label.name":"Name{required, select, true {*} other {}} (this appears publicly)","field-label.email":"Email{required, select, true {*} other {}} (this will be kept private)","field-label.add-images":"Add images{required, select, true {*} other {}} ({count}/{limit})","field-label.add-videos":"Add videos{required, select, true {*} other {}} ({count}/{limit})","field-label.add-images-videos":"Add images & videos{required, select, true {*} other {}} ({count}/{limit})","review-form.aria-label-edit":"Edit review","review-form.aria-label-create":"Leave a review","close-button.aria-label":"Close","review-form.cancel":"Cancel","review-form.update":"Update","review.media-aria-label":"Media","media-error.template":"Could not upload {filename}: {message}","media-error.generic":"Temporary technical issue","review.media-thumbnail-aria-label":"Media file {filename}","empty-state.list-loading-text":"Loading…","review.media-input-remove-button":"Remove","clear-button.aria-label":"Clear","field-label.title.default":"Review title","field-label.body.default":"Review","review-form.publish.default":"Publish","top-section.cta.default":"Leave a Review","field-label.star-rating.default":"Add a rating","preview-blocker.title":"To write reviews, head to your live site.","preview-blocker.popup":"To test this feature, visit your live site."};
    var styleHocConfig = {"enabled":true};
    var biConfig = {"enableUniversalEvents":true};
    var appDefinitionId = "a95a5fce-e370-4402-9ce4-96956acc747d";
    var componentId = "d79273d8-cd93-479f-8818-4f485b1e0c84";
    var localeDistPath = 'components/CollectionWidget/locales/widget';
    var persistentAcrossPages = false;
    var shouldUseEssentials = true;
    var shouldSkipMultipleRendersAfterViewModeChange = false;
    var withErrorBoundary = false;

    import { createVisitorBILogger as biLogger } from '/home/builduser/work/7316bfa601ecc640/reviews-web/wix-reviews/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      styleHocConfig: styleHocConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      multilingualDisabled,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      persistentAcrossPages,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      customCssVars,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
